export const GET_GAMES_REQUEST = 'GET_GAMES_REQUEST';
export const GET_GAMES_SUCCESS = 'GET_GAMES_SUCCESS';
export const GET_GAMES_FAILURE = 'GET_GAMES_FAILURE';
export const GET_GAME_REQUEST = 'GET_GAME_REQUEST';
export const GET_GAME_SUCCESS = 'GET_GAME_SUCCESS';
export const GET_GAME_FAILURE = 'GET_GAME_FAILURE';
export const CREATE_GAME_REQUEST = 'CREATE_GAME_REQUEST';
export const CREATE_GAME_SUCCESS = 'CREATE_GAME_SUCCESS';
export const CREATE_GAME_FAILURE = 'CREATE_GAME_FAILURE';
export const UPDATE_GAME_REQUEST = 'UPDATE_GAME_REQUEST';
export const UPDATE_GAME_SUCCESS = 'UPDATE_GAME_SUCCESS';
export const UPDATE_GAME_FAILURE = 'UPDATE_GAME_FAILURE';
export const DELETE_GAME_REQUEST = 'DELETE_GAME_REQUEST';
export const DELETE_GAME_SUCCESS = 'DELETE_GAME_SUCCESS';
export const DELETE_GAME_FAILURE = 'DELETE_GAME_FAILURE';
export const RELEASE_GAME_ANSWER_REQUEST = 'RELEASE_GAME_ANSWER_REQUEST';
export const RELEASE_GAME_ANSWER_SUCCESS = 'RELEASE_GAME_ANSWER_SUCCESS';
export const RELEASE_GAME_ANSWER_FAILURE = 'RELEASE_GAME_ANSWER_FAILURE';
export const GET_ANCHOR_CATEGORIES_REQUEST = 'GET_ANCHOR_CATEGORIES_REQUEST';
export const GET_ANCHOR_CATEGORIES_SUCCESS = 'GET_ANCHOR_CATEGORIES_SUCCESS';
export const GET_ANCHOR_CATEGORIES_FAILURE = 'GET_ANCHOR_CATEGORIES_FAILURE';
export const CLEAR_ALL_GAMES_DATA = 'CLEAR_ALL_GAMES_DATA';
export const CLEAR_A_GAME = 'CLEAR_A_GAME';
export const CLEAR_ALL = 'CLEAR_ALL';
export const CLEAR_CREATE_GAME = 'CLEAR_CREATE_GAME';
export const CLEAR_UPDATE_GAME = 'CLEAR_UPDATE_GAME';
export const CLEAR_DELETE_GAME = 'CLEAR_DELETE_GAME';

export const getGamesRequest = (data) => ({
    type: GET_GAMES_REQUEST,
    payload: data,
});
export const getGamesSuccess = (data) => ({
    type: GET_GAMES_SUCCESS,
    payload: data,
});
export const getGamesFailure = (data) => ({
    type: GET_GAMES_FAILURE,
    payload: data,
});

export const getAnchorCategoriesRequest = (data) => ({
    type: GET_ANCHOR_CATEGORIES_REQUEST,
    payload: data,
});
export const getAnchorCategoriesSuccess = (data) => ({
    type: GET_ANCHOR_CATEGORIES_SUCCESS,
    payload: data,
});
export const getAnchorCategoriesFailure = (data) => ({
    type: GET_ANCHOR_CATEGORIES_FAILURE,
    payload: data,
});

export const getGameRequest = (data) => ({
    type: GET_GAME_REQUEST,
    payload: data,
});
export const getGameSuccess = (data) => ({
    type: GET_GAME_SUCCESS,
    payload: data,
});
export const getGameFailure = (data) => ({
    type: GET_GAME_FAILURE,
    payload: data,
});

export const createGameRequest = (data) => ({
    type: CREATE_GAME_REQUEST,
    payload: data,
});
export const createGameSuccess = (data) => ({
    type: CREATE_GAME_SUCCESS,
    payload: data,
});
export const createGameFailure = (data) => ({
    type: CREATE_GAME_FAILURE,
    payload: data,
});

export const updateGameRequest = (data) => ({
    type: UPDATE_GAME_REQUEST,
    payload: data,
});
export const updateGameSuccess = (data) => ({
    type: UPDATE_GAME_SUCCESS,
    payload: data,
});
export const updateGameFailure = (data) => ({
    type: UPDATE_GAME_FAILURE,
    payload: data,
});

export const deleteGameRequest = (error) => ({
    type: DELETE_GAME_REQUEST,
    payload: error,
});
export const deleteGameSuccess = (data) => ({
    type: DELETE_GAME_SUCCESS,
    payload: data,
});
export const deleteGameFailure = (error) => ({
    type: DELETE_GAME_FAILURE,
    payload: error,
});

export const releaseGameAnswerGameRequest = (data) => ({
    type: RELEASE_GAME_ANSWER_REQUEST,
    payload: data,
});
export const releaseGameAnswerSuccess = (data) => ({
    type: RELEASE_GAME_ANSWER_SUCCESS,
    payload: data,
});
export const releaseGameAnswerFailure = (data) => ({
    type: RELEASE_GAME_ANSWER_FAILURE,
    payload: data,
});

export const clearGames = (data) => ({
    type: CLEAR_ALL_GAMES_DATA,
    payload: data,
});
export const clearOnlyGame = (data) => ({
    type: CLEAR_A_GAME,
    payload: data,
});
export const clearDeleteGame = (data) => ({
    type: CLEAR_DELETE_GAME,
    payload: data,
});
export const clearCreateGame = (data) => ({
    type: CLEAR_CREATE_GAME,
    payload: data,
});

export const clearUpdateGame = (data) => ({
    type: CLEAR_UPDATE_GAME,
    payload: data,
});

// export const clearAll = (data) => ({
//     type: CLEAR_ALL,
//     payload: data,
// })